import React from "react";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";

const requestHeaderTableData = {
  columns: [
    // { Header: "S/N", accessor: "num", align: "left", width: "5%" },
    // { Header: "Key", accessor: "key", align: "left", width: "20%" },
    // { Header: "Value", accessor: "value", align: "left" },
  ],
  rows: [
    {
      num: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          1
        </MDTypography>
      ),
      key: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          Authorization
        </MDTypography>
      ),
      value: (
        <MDTypography
          component="p"
          variant="caption"
          color="text"
          fontWeight="regular"
        >
          {"Bearer <access_token>"}
        </MDTypography>
      ),
    },
  ],
};

const requestBodyColumnHeaders = [
  { Header: "S/N", accessor: "num", align: "left", width: "5%" },
  { Header: "Field Name", accessor: "fieldName", align: "left", width: "20%" },
  { Header: "", accessor: "dataType", align: "center", width: "10%" },
  { Header: "Description", accessor: "description", align: "left" },
];

let fundingApiData = [
  {
    mainHeadingStatic: "Introduction",
    mainGridIdStatic: "introduction",
    mainHeadingDescStatic:
      "The Journal Entry API creates a journal entry file in CSV format, posts it to InteliClear, and sends an email notification to the respective personnel.",
  },
  {
    mainHeadingStatic: "REQUIRED INPUT FOR EXTERNAL API",
    mainGridIdStatic: "authorization",
    mainHeadingDescStatic: "For Base URL, please contact product support :",
    email: ["customersupport@logicielservice.com"],
  },
  {
    SampleCode: true,
    SampleCodeTitle: "HTTP Client Request C# :",
    sampleCodeType: "auth",
    index: 0,
    mainHeading: "Authorization",
    mainHeadingDesc:
      "User will provide credentials to get token to access external fund request API. Credentials should be in JSON format and request type should be POST.",
    mainHeadingDescTwo: "For credentials, please contact product support :",
    email: ["customersupport@logicielservice.com"],
    mainHeadingDescThree:
      "To get the access token, credentials must be passed to the API using the URL below:",
    mainGridId: "authorization",
    // accessTokenId: "",
    endPointHeading: "Request Endpoint",
    endpointId: "get-access-token-request-endpoint",
    endPointMethod: "POST",
    endPointDesc: "<base-url>/api/Authentication/login",
    requestBody: "Request Body",
    requestBodyId: "get-access-token-request-body",
    sampleCodeNote:
      "You can get the Expiry in the login API JSON response and by decoding the JWT, currently its set to 5 minutes",
    requestBodyTable: {
      columns: [...requestBodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Email<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
              style={{ overflowX: "none" }}
            >
              extuser@ext.com
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Password<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              extuserpass
            </MDTypography>
          ),
        },
      ],
    },
    respObjKey: "journal_success_response",
  },
  {
    SampleCode: true,
    SampleCodeTitle: "HTTP Client Request C# :",
    sampleCodeType: "postJournalEntry",
    mainHeading: "Post Journal Entry",
    mainHeadingDesc:
      "The user will supply the access token obtained from the login API in the authorization header, along with the necessary parameters.",
    mainHeadingDescTwo:
      "Please note, this endpoint will handle one entry at a time.",
    mainHeadingDescThree:
      "you will have to provide the access_token received in the auth/login Api response in this JournalEntry/PostJournalEntry request . when using postman select bearer_token",
    mainHeadingDescFour:
      "Our API is strictly available during business hours: 8:00 AM to 4:00 PM (EST), Monday to Friday. Any requests made outside these hours will receive a 503 Service Unavailable response and will not be queued or processed. Please ensure all API interactions are scheduled within the defined time window.",
    mainGridId: "post-journal-entry",
    endPointHeading: "Request Endpoint",
    endpointId: "post-journal-entry-endpoint",
    endPointMethod: "POST",
    endPointDesc: "{{base-url}}/API/JournalEntry/PostJournalEntry",
    requestBody: "Possible Values and Validations :",
    requestBodyId: "post-journal-entry-validations",
    requestBodyDesc: (
      <>
        1. Transaction Type[Required][DataType=String] : "Deposit" or
        "Withdrawal".
        <br />
        <br />
        2. Backoffice Account Number [Required][DataType=String]:
        XXXX-XXX-000001-X OR XXXX-XXX-000001-XX, X is indicating alphabets. The
        Velocity Account Number for which the journal entry applies. This
        corresponds to the client-provided VelocityID. Must be in the format:
        CORR-OFFICE-ACCT_NO-ACCT_TYPE.
        <br />
        <br />
        3. Amount [Required][DataType=decimal] : Amount must be a positive
        decimal number between 0.01 and 1,000,000,000 (1 billion).
        <br />
        <br />
        4. External Id [Required][DataType=String]:
        <br />
        <br />
        5. Trade Date [Required][DataType=Datetime]
      </>
    ),
    requestBodyTable: {
      columns: [...requestBodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              backofficeAccountNumber<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              AAAA-AAA-980734-C
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              transactionType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Deposit
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              amount<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              0.01
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              externalId<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              tradeDate<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"DateTime"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              2025-05-15T06:29:46.495Z
            </MDTypography>
          ),
        },
      ],
    },
    reqObjKey: "post_journal_entry_request",
    respObjKey: "post_journal_entry_success_response",
  },
  {
    SampleCode: true,
    SampleCodeTitle: "HTTP Client Request C# :",
    sampleCodeType: "postJournalEntryBatch",
    mainHeading: "Post Journal Entry (Batch)",
    mainHeadingDesc:
      "The user will supply the access token obtained from the login API in the authorization header, along with the necessary parameters.",
    mainHeadingDescTwo: "This endpoint can handle multiple Journal Entries.",
    mainHeadingDescThree:
      "you will have to provide the access_token received in the auth/login Api response in this JournalEntry/PostJournalEntryBatch request . when using postman select bearer_token",
    mainHeadingDescFour:
      "Our API is strictly available during business hours: 8:00 AM to 4:00 PM (EST), Monday to Friday. Any requests made outside these hours will receive a 503 Service Unavailable response and will not be queued or processed. Please ensure all API interactions are scheduled within the defined time window.",
    mainGridId: "post-journal-entry-batch",
    endPointHeading: "Request Endpoint",
    endpointId: "post-journal-entry-batch-endpoint",
    endPointMethod: "POST",
    endPointDesc: "{{base-url}}/API/JournalEntry/PostJournalEntryBatch",
    requestBody: "Possible Values and Validations :",
    requestBodyId: "post-journal-entry-batch-validations",
    extraLine:
      "Maximum of 100 Journal Entries can be processed through this API Endpoint At a time.",
    requestBodyDesc: (
      <>
        1. Transaction Type[Required][DataType=String] : "Deposit" or
        "Withdrawal".
        <br />
        <br />
        2. Backoffice Account Number [Required][DataType=String]:
        XXXX-XXX-000001-X OR XXXX-XXX-000001-XX, X is indicating alphabets. The
        Velocity Account Number for which the journal entry applies. This
        corresponds to the client-provided VelocityID. Must be in the format:
        CORR-OFFICE-ACCT_NO-ACCT_TYPE.
        <br />
        <br />
        3. Amount [Required][DataType=decimal] : Amount must be a positive
        decimal number between 0.01 and 1,000,000,000 (1 billion).
        <br />
        <br />
        4. External Id [Required][DataType=String]:
        <br />
        <br />
        5. Trade Date [Required][DataType=Datetime]
      </>
    ),
    requestBodyTable: {
      columns: [...requestBodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              backofficeAccountNumber<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              AAAA-AAA-988425-C
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              transactionType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Deposit
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              amount<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              0.01
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              externalId<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              tradeDate<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              2025-05-15T06:32:03.675Z
            </MDTypography>
          ),
        },
      ],
    },
    requestBodyTableTwo: {
      columns: [...requestBodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              backofficeAccountNumber<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              AAAA-AAA-988425-PX
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              transactionType<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Withdrawal
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              amount<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              0.01
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              externalId<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            ></MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          fieldName: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              tradeDate<span style={{ color: "#ff4848" }}>*</span>
            </MDTypography>
          ),
          dataType: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              2025-05-15T06:32:03.675Z
            </MDTypography>
          ),
        },
      ],
    },
    reqObjKey: "post_journal_entry_batch_request",
    respObjKey: "post_journal_entry_batch_success_response",
  },
  {
    mainHeadingStatic: "Transaction Mapping for Journal Entries",
    mainGridIdStatic: "transaction-mapping-for-journal-entries",
    mainHeadingDescStatic: (
      <div>
        <div style={{ marginBottom: "16px" }}>
          When processing transactions, note the following mappings for accurate
          journal entries:
        </div>
        <div style={{ marginBottom: "8px" }}>
          • Deposit → WIREI: <br /> If the user provides a Deposit, the system
          will treat it as WIREI.
        </div>
        <div>
          • Withdrawal → WIREO: <br />
          If the user provides a Withdrawal, the system will retain it as WIREO.
        </div>
      </div>
    ),
  },

  {
    mainHeadingStatic: "Disclaimer and Confidentiality Notice",
    mainGridIdStatic: "disclaimer",
    mainHeadingDescStatic: `The information contained in these documents is confidential, privileged, and only for the understanding of the intended recipient and may not be used, published, or redistributed without prior written consent from VCT Technologies LLC.`,
    mainHeadingDescStaticTwo: `The information is provided with care in these documents, VCT Technologies LLC makes no representations and gives no warranties of whatever nature in respect of these documents, including, but not limited to, the accuracy or completeness of any information, facts, and/or opinions contained therein. VCT Technologies LLC, its subsidiaries, the directors, employees, and agents cannot be held liable for the use of, and reliance on the information provided in these documents.`,
  },
];

export default fundingApiData;
